import CustomCard from "@/components/v-pos/custom-card.component";
import { formatPersianDate, numberSeparator } from "@/lib/helper";
import EditDataDrawer from "./edit-data-drawer.component";
import StatusVPosLinkDialog from "../../_components/status-vpos-link-dialog.component";
import { virtualPosItem } from "@/lib/types/DTO/core";
import { FC } from "react";
import { FaCircleCheck } from "react-icons/fa6";

type TransactionCardProps = virtualPosItem;

const TransactionCard: FC<TransactionCardProps> = (item) => {
  const {
    id,
    mobile,
    amount = 0,
    description,
    fullName,
    createdAt,
    infoUpdatedAt: updatedAt,
  } = item;

  return (
    <CustomCard className="flex items-center  py-2 pl-[8px] pr-[13.5px]  gap-2 border-2 border-gray-200 rounded-4xl ">
       <div className="flex basis-4/6 flex-col items-center text-center gap-2">
        <div className="flex flex-col gap-2 items-center justify-center content-center">
          <p className="flex text-sm xs:text-base items-center justify-center ">
            <span className="text-sm">شماره موبایل:</span>
            <span className="font-bold">{mobile ?? "نامعتبر"}</span>
            
          </p>
          <div className="flex flex-row items-center justify-center gap-1">
            <span className="text-sm">مبلغ</span>
            <span className="text-base font-bold">
              {numberSeparator({ value: String(amount), type: "money" })}
            </span>
            <span className="text-sm"> ریال</span>
          </div>
        </div>
        
        <div className="flex flex-row gap-1">

          <span className="text-sm">
            {formatPersianDate({
              dateString: createdAt,
              mode: "onlyDate",
              format: "text",
            })}
          </span>
          <span className="text-sm">
            {formatPersianDate({
              dateString: createdAt,
              mode: "onlyTime",
              format: "text",
            })}
          </span>
        </div>


      </div>

      <div className="flex basis-1/6 flex-col items-center">
        <StatusVPosLinkDialog
        canOpen={!item.isPaid}
          linkId={id}
          buttonTrigger={(check) => {
            return check ? (
              <FaCircleCheck  className="text-3xl text-green-700/70 cursor-pointer" />
            ) : (
              <p className="cursor-pointer text-xs xs:text-sm rounded-2xl border border-[#F89521] bg-[#FEECD7] hover:bg-[#F895210F] text-[#F89521] py-[11px] px-[3px] xs:px-[7.5px]  font-bold">
                استعلام
              </p>
            );
          }}
          itemsDetails={item}
        />
      </div>

      <div className="flex basis-1/6 justify-center">
        <EditDataDrawer
          key={updatedAt}
          description={description}
          fullName={fullName}
          updatedAt={updatedAt ?? ""}
          reportId={id}
        />
      </div>
    </CustomCard>
  );
};

export default TransactionCard;
